<template>
    <div>
        <interest-list v-if="interests.length > 0"/>

        <info-block v-if="interests.length === 0">
            <p class="info-text">Váš projekt neobsahuje žádné zájemce.</p>
        </info-block>
    </div>
</template>

<script>
import InterestList from '@/modules/ProjectModule/modules/CustomerModule/components/Interest/InterestList';
import InfoBlock from '@/components/Block/InfoBlock';

export default {
    name:       'InterestContainer',
    components: { InfoBlock, InterestList },
    computed:   {
        interests() {
            return this.$store.getters['projects/project/customer/interest/interests'];
        }
    }
}
</script>
